<template>
  <div>
    <card
      v-for="sess in sessions"
      :key="sess.SessionNumber"
    >
      <div class="card-header">
        {{ sess.SessionName }}
      </div>
      <div class="card-body">
        <ValidationObserver ref="form">
          <form @submit.prevent="validate(sess.SessionNumber)">
            <div class="row">
              <div class="col-sm-12 col-md-4 col-lg-4">
                <ValidationProvider
                  name="startdate"
                  rules="required"
                >
                  <fg-input
                    slot-scope="{ errors }"
                    :error="errors[0] ? 'Start Date is Required.': ''"
                  >
                    <label>Start Date <span class="text-danger">*</span></label>
                    <el-date-picker
                      name="startDate"
                      v-model="sess.StartDate"
                      type="datetime"
                      :clearable="showClearButton"
                      format="MMM d, yyyy     h:mm a"
                      value-format="yyyy-MM-ddTHH:mm:ss"
                      placeholder="Select date and time"
                    />
                  </fg-input>
                </ValidationProvider>
                <ValidationProvider
                  name="endDate"
                  rules="required"
                >
                  <fg-input
                    slot-scope="{ errors }"
                    :error="errors[0] ? 'End Date is Required.': ''"
                  >
                    <label>End Date <span class="text-danger">*</span></label>
                    <el-date-picker
                      name="endDate"
                      v-model="sess.EndDate"
                      type="datetime"
                      :clearable="showClearButton"
                      format="MMM d, yyyy     h:mm a"
                      value-format="yyyy-MM-ddTHH:mm:ss"
                      placeholder="Select date and time"
                    />
                  </fg-input>
                </ValidationProvider>
                <ValidationProvider
                  name="locationName"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <label
                    style="margin-top:1.5rem"
                  >
                    Location <span class="text-danger">*</span>
                  </label>
                  <p-button
                    class="float-right mb-0"
                    style="margin-top:1.25rem;"
                    v-if="sess.SessionNumber===2"
                    type="info"
                    :title="locationChangeTitle"
                    link
                    size="sm"
                    @click="changeLocationDialog"
                  >
                    {{ locationChangeText }}
                  </p-button>
                  <fg-input
                    name="locationName"
                    :error="failed ? 'The Location Name is required': null"
                    :has-success="passed"
                    required
                    :readonly="sess.SessionNumber === 2 && sessions[0].LocationId === sessions[1].LocationId"
                    placeholder="Location Name"
                    max-length="255"
                    v-model="sess.Location.LocationName"
                  />
                </ValidationProvider>
                <div v-if="sess.SessionNumber === 1 || sessions[0].LocationId !== sessions[1].LocationId">
                  <label>Street Address</label>
                  <fg-input
                    name="streetAddress1"
                    placeholder="Address Line 1"
                    max-length="255"
                    class="mb-0"
                    v-model="sess.Location.StreetAddress1"
                  />
                  <fg-input
                    name="streetAddress2"
                    placeholder="Address Line 2"
                    max-length="255"
                    v-model="sess.Location.StreetAddress2"
                  />
                  <label>City, State, Zip Code</label>
                  <fg-input
                    name="city"
                    placeholder="City"
                    max-length="255"
                    class="mb-0"
                    v-model="sess.Location.City"
                  />
                  <fg-input class="mb-0">
                    <el-select
                      class="select-default2"
                      size="large"
                      name="state"
                      placeholder="Select State"
                      v-model="sess.Location.State"
                    >
                      <el-option
                        v-for="option in states"
                        class="select-default2"
                        :value="option.key"
                        :label="option.name"
                        :key="option.key"
                      />
                    </el-select>
                  </fg-input>
                  <fg-input
                    name="zipCode"
                    placeholder="Zip Code"
                    max-length="10"
                    type="tel"
                    pattern="\d{5}-?(\d{4})?"
                    v-model="sess.Location.ZipCode"
                  />
                </div>
              </div>
              <div class="col-sm-12 col-lg-8 col-md-8">
                <fg-input>
                  <label>Special Instructions</label>
                  <ckeditor
                    :editor="editor"
                    v-model="sess.Instructions"
                    max-length="7000"
                    :config="editorConfig"
                  />
                </fg-input>
                <div v-if="sess.SessionNumber === 1 || sessions[0].LocationId !== sessions[1].LocationId">
                  <fg-input
                    name="url"
                    placeholder=""
                    max-length="1000"
                    label="Google Maps URL"
                    v-model="sess.Location.GoogleMapUrl"
                  />
                  <fg-input>
                    <label>Written Directions</label>
                    <ckeditor
                      :editor="editor"
                      v-model="sess.Location.Directions"
                      max-length="6000"
                      :config="editorConfig"
                    />
                  </fg-input>
                </div>
              </div>
            </div>
            <div class="text-center">
              <button
                type="submit"
                class="btn btn-info btn-fill btn-wd"
              >
                Update {{ sess.SessionName }} Session Info
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </card>
  </div>
</template>

<script>
import sessionApi from '@/services/api/session'
import statesList from '@/services/static/states'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { extend } from 'vee-validate'
import { required, max } from 'vee-validate/dist/rules'

extend('required', required)
extend('max', max)

export default {
  name: 'CourseSessionEdit',
  components: {
    ckeditor: CKEditor.component
  },
  data: function () {
    return {
      showClearButton: false,
      sessions: {},
      errormessage: null,
      states: null,
      editor: ClassicEditor,
      editorConfig: {},
      locationChangeTitle: '',
      locationChangeText: '',
      tempHolding: null
    }
  },
  computed: {
    sameLocation: function () {
      if (this.session2.LocationId === this.session1.LocationId) {
        return 'same'
      } else {
        return 'not'
      }
    }
  },
  created () {
    this.states = statesList.GetStates()
  },
  mounted () {
    sessionApi.get(this.$root.courseKey)
      .then(x => {
        this.sessions = x
        this.session1 = x[0]
        if (x.length > 1) {
          this.session2 = x[1]
          this.setLocationChangeLabels()
        }
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    setLocationChangeLabels: function () {
      if (this.sessions.length > 0) {
        if (this.sessions[0].LocationId === this.sessions[1].LocationId) {
          this.locationChangeTitle = "Make the second weekend's location different from the first weekend's"
          this.locationChangeText = 'new location'
        } else {
          this.locationChangeTitle = "Make the second weekend's location the same as the first weekend's"
          this.locationChangeText = 'same as weekend 1'
        }
      }
    },
    changeLocationDialog: function () {
      if (this.sessions[0].LocationId === this.sessions[1].LocationId) {
        this.makeLocationsDifferentDialog()
      } else {
        this.makeLocationsSameDialog()
      }
    },
    makeLocationsDifferentDialog: function () {
      const msg = 'Are you sure you want to move Weekend #2 to a different location than Weekend #1?'
      this.$confirm(msg, {
        title: 'Are you sure?',
        buttonSize: 'sm',
        centered: true
      }).then(() => {
        this.sessions[1].LocationId = null
        this.sessions[1].Location = {
          Directions: '<p></p>'
        }
        this.setLocationChangeLabels()
      })
    },
    makeLocationsSameDialog: function () {
      const msg = 'Are you sure you want to move Weekend #2 to the same location as Weekend #1?' +
                  '  If you wish to change to separate locations in the future you will need ' +
                  'to re-enter all location information.'
      this.$confirm(msg, {
        title: 'Are you sure?',
        buttonSize: 'sm',
        centered: true
      }).then(() => {
        this.sessions[1].LocationId = this.sessions[0].LocationId
        this.updateSession(this.sessions[1])
        this.setLocationChangeLabels()
      })
    },
    validate: function (sessionNumber) {
      return this.$refs.form.validate().then(res => {
        this.updateSession(this.sessions[sessionNumber - 1])
        return res
      })
    },
    updateSession: function (session) {
      this.tempHolding = session
      sessionApi.update(this.$root.courseKey, session)
        .then(x => {
          this.sessions = x
          this.$notify({
            message: 'The session has been updated.',
            icon: 'nc-icon nc-satisfied',
            type: 'success',
            horizontalAlign: 'center',
            timeout: 2000
          })
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error updating your session.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
